import { Product } from "../../types/types";
export function getDefaultCategory(product: Product): string {
  // @ts-ignore
  return product.browsePageHierarchy[product.browsePageHierarchy.length - 1]
    ?.name;
}
